import { Avatar } from '@amityco/diana-bot';
import React from 'react';
import { AVATAR_DEFAULT_URL } from 'constants/cim_user_info';
import { Container, UserNameAndEmailWrap, UserName, UserEmail } from './_style';

export const UserAvatar = ({
  imgUrl = AVATAR_DEFAULT_URL,
  username = 'username',
  userEmail = 'user@email.co',
}) => {
  return (
    <Container>
      <Avatar imgUrl={imgUrl} />
      <UserNameAndEmailWrap>
        <UserName>{username}</UserName>
        <UserEmail>{userEmail}</UserEmail>
      </UserNameAndEmailWrap>
    </Container>
  );
};
